module.exports = __webpack_public_path__ + "img/background-add-study.1eb7be78.jpg";